function ErrorText({ styleClass, children }) {
  return <p className={`mt-2 text-sm text-error ${styleClass}`}>{children}</p>;
}

export default ErrorText;
